module.exports = __webpack_public_path__ + "img/f8ae0d1.png";